import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { StreamHistoryReport } from '../../../_models';
import { NotificationService,  StreamKeywordService, StreamHistoryService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stream-history-report',
  templateUrl: './stream-history-report.component.html'
})
export class StreamHistoryReportComponent implements OnInit {

  loading = false;
  loaded = false;
  processing = false;
  exporting = false;
  totalItems = 0;
  emptyResult = true;
  downloadUrl = '';

  streamReports: Array<StreamHistoryReport> = [];

  keywordList = [];
  shortCodeFilterList = [];
  shortCodeList = {};
  operatorList: any = [];

  filterable = {
    fromDate: '',
    toDate: '',
    shortCode: '',
    keyword: '',
    operator: ''
  };

  constructor(
    private streamHistorySvc: StreamHistoryService,
    private keywordSvc: StreamKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.toDate = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);

    this.loadShortCodes();
  }

  search() {
    this.loadPage();
  }

  export() {
    this.exporting = true;
    let params = {
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword,
      operator: this.filterable.operator
    }
    this.streamHistorySvc.reportExport(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeShortCode(shortCode) {
    this.operatorList = [];
    this.keywordList = [];
    this.filterable.keyword = '';
    this.filterable.operator = '';
    if (shortCode) {
      this.keywordList = Object.keys(this.shortCodeList[shortCode]);
      this.filterable.keyword = this.keywordList[0];
      this.changeKeyword(this.filterable.keyword);
    }
  }

  changeKeyword(keyword) {
    this.operatorList = [];
    this.filterable.operator = '';
    if (keyword) {
      this.operatorList = this.shortCodeList[this.filterable.shortCode][this.filterable.keyword];
      this.filterable.operator = this.operatorList[0];
    }
  }

  private loadShortCodes() {
    this.keywordSvc.getSelection().pipe(first()).subscribe(data => {
      this.shortCodeList = data.data;
      console.log(this.shortCodeList);
      this.shortCodeFilterList = Object.keys(this.shortCodeList);
      this.filterable.shortCode = this.shortCodeFilterList[0];
      this.changeShortCode(this.filterable.shortCode);
    });
  }

  private loadPage() {
    this.loading = true;
    this.emptyResult = false;
    this.streamReports = [];
    this.totalItems = 0;
    let params = {
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword,
      operator: this.filterable.operator
    }

    // get page of items from api
    this.streamHistorySvc.getDailyReport(params).pipe(first()).subscribe(data => {
      if (data !== null && data.data != null) {
        this.loading = false;
        this.emptyResult = false;
        this.streamReports = data.data;
        this.totalItems = data.data.length;
        this.loaded = true;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for Stream Daily Report.", "Empty Result");
      }
    });
  }

}
